import type { RouteRecordRaw } from 'vue-router';
import { DeliveryBoardRouteNames, DeliveryBoardRoutePath } from './enums';

const DeliveryBoard = () => import('./DeliveryBoard.vue');

export * from './enums';
export * from './types';

/**
 * Public, chrome-less runner board. Registered as a top-level sibling of the
 * authenticated shell; `meta.public` tells the app's auth guard to let it
 * through without a token.
 */
export const route: RouteRecordRaw = {
  path: DeliveryBoardRoutePath,
  name: DeliveryBoardRouteNames.DELIVERY_BOARD,
  component: DeliveryBoard,
  meta: {
    public: true,
  },
};
